import tippy, { delegate } from 'tippy.js';

delegate(document.body, {
    target: '.js-tooltip',
    theme: 'jobtek',
    content(reference: any ) {
      return reference.getAttribute('data-tooltip') ?? 'No tooltip message';
    },
    allowHTML: true,
    interactive: true,
    appendTo: () => document.body,
  });